<div class="modal-content">

  <div class="modal-header">
    <h5 class="modal-title" id="modal-title-login">{{'School' | translate}}</h5>
    <button tabindex="10" type="button" class="close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="form-group">
      <label>{{'Name' | translate}} *</label>
      <input class="form-control" autocomplete="off" [(ngModel)]="entity.name" />
    </div>

    <div class="form-group">
      <label>{{'Type' | translate}} *</label>
      <select class="form-control" [(ngModel)]="entity.schoolType">
        <option *ngFor="let option of educationSchoolTypes" [value]="option['value']">{{option['label'] | translate}}</option>
      </select>
    </div>

    <div class="form-group">
      <label>{{'Image' | translate}}</label>
      <div class="custom-file">
        <input type="file" class="custom-file-input" (change)="fileChangeEvent($event)" id="photoFile">
        <label class="custom-file-label" for="photoFile" [attr.data-browse]="'Select file' | translate">{{'Upload a new profile image' | translate}}</label>
      </div>

      <div class="current-image-wrapper" *ngIf="entity.avatarUri">
        {{'Current image' | translate}}
        <img [src]="entity.avatarUri" class="image img-64" />
      </div>
    </div>

    <h3>{{'Address' | translate}}</h3>

    <div class="row">

      <div class="col-sm-8">
        <div class="form-group">
          <label>{{'Street' | translate}} *</label>
          <input type="text" class="form-control" autocomplete="off" [(ngModel)]="entity.address.street" />
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <label>{{'No.' | translate}} *</label>
          <input type="text" class="form-control" autocomplete="off" [(ngModel)]="entity.address.number" />
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <label>{{'Addition' | translate}}</label>
          <input type="text" class="form-control" autocomplete="off" [(ngModel)]="entity.address.numberSuffix" />
        </div>
      </div>

      <div class="col-sm-8">
        <div class="form-group">
          <label>{{'City' | translate}} *</label>
          <input type="text" class="form-control" autocomplete="off" [(ngModel)]="entity.address.city" />
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group">
          <label>{{'Postal code' | translate}} *</label>
          <input type="text" class="form-control" autocomplete="off" [(ngModel)]="entity.address.postalCode" />
        </div>
      </div>

      <div class="col-12">
        <div class="form-group">
          <label>{{'Country' | translate}} *</label>
          <select class="form-control" autocomplete="off" [(ngModel)]="entity.address.country">
            <option *ngFor="let option of locale.availableCountries()" [value]="option.code">{{option.name}}</option>
          </select>
        </div>
      </div>

    </div>

  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1 justify-content-between">
      <button type="button" class="btn btn-secondary" (click)="activeModal.close(false)">{{'Cancel' | translate}}</button>
      <button type="button" class="btn btn-primary" (click)="Save()">{{'Save' | translate}}</button>
    </div>
  </div>
</div>
